/* Our color scheme for our charts */
const colors = ['#c0dffe', '#a5d2fe', '#7fc0ff', '#4ca7ff', '#198dff', '#0074e5'];

export default colors;
